export class FileItem {
    public archivo: File;
    public nombreArchivo: string;
    public url: string;
    public estado: boolean;
    public progreso: number;

    constructor( file: File ) {

    this.archivo = file;
    this.nombreArchivo = file.name;
    this.estado = false;
    this.progreso = 0;

    }
}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/models/FileItem.ts